// extracted by mini-css-extract-plugin
export var displayNone = "_uo-6";
export var imgContainer = "_uo-2";
export var overflowHidden = "_uo-3";
export var productInfoCardButtonContainer = "_uo-5";
export var productTitleText = "_uo-4";
export var rightArrow = "_uo-1";
export var rightArrowContainer = "_uo-0";